(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/views/prolong-empty.js') >= 0) return;  svs.modules.push('/modules/maltipset/views/prolong-empty.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.maltipset=_svs.maltipset||{};
_svs.maltipset.templates=_svs.maltipset.templates||{};
svs.maltipset.templates.prolong_empty = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"padding-1\">\n    Inga avgjorda spel.\n</div>";
},"useData":true});
Handlebars.partials['svs-maltipset-prolong_empty'] = svs.maltipset.templates.prolong_empty;
})(svs, Handlebars);

 })(window);